import { render, staticRenderFns } from "./StaggeredImages.vue?vue&type=template&id=f5442dfc&scoped=true"
import script from "./StaggeredImages.vue?vue&type=script&lang=js"
export * from "./StaggeredImages.vue?vue&type=script&lang=js"
import style0 from "./StaggeredImages.vue?vue&type=style&index=0&id=f5442dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5442dfc",
  null
  
)

export default component.exports